export const validateDomain = (domain: string): boolean => {
  const domainRegex =
    /^(https?:\/\/)?(([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,})(\/.*)?$/;
  return domainRegex.test(domain);
};
